module.exports = __webpack_public_path__ + "img/search-hero-overflow-toyota.e3bb090b.png";